import { List } from "linq.ts";
import { isNullOrEmpty } from "./isNullOrEmpty";
import { DataTableRequest } from "../data";
export const paginateDataAsync = async (request, options) => {
    return paginateData(request, options);
};
export const paginateData = (request, options) => {
    const req = request instanceof DataTableRequest ? request.toJson() : Object.assign({}, request);
    let result = new List(options.data().slice());
    const order = options.order || [];
    if (req.search && req.search.trim().length > 0) {
        const search = req.search.trim().toUpperCase();
        result = result.Where((item) => {
            if (options.onSearch != null) {
                return options.onSearch(search, item);
            }
            else {
                const values = options.search != null ? options.search(item) : [];
                if (values.length === 0) {
                    return true;
                }
                else {
                    for (let i = 0; i < values.length; i++) {
                        const value = values[i].toUpperCase();
                        if (!isNullOrEmpty(value) && value.indexOf(search) >= 0) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        });
    }
    if (typeof options.onSort === 'function') {
        result = options.onSort(result);
    }
    else {
        if (req.orderColumn !== void 0) {
            const orderColumn = order[req.orderColumn];
            if (orderColumn !== void 0) {
                if (req.sortDirection === 'asc') {
                    result = result.OrderBy(o => o[orderColumn]);
                }
                else {
                    result = result.OrderByDescending(o => o[orderColumn]);
                }
            }
        }
    }
    const count = result.Count();
    req.start = (req.start - 1) < 0 ? 0 : (req.start - 1);
    result = result.Skip(req.start * req.length).Take(req.length);
    const dtResult = {
        data: result.ToArray(),
        recordsFiltered: count
    };
    return dtResult;
};
